<template>
  <svg width="24"
       height="26"
       viewBox="0 0 24 26"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.3998 3.40001C2.3998 2.55132 2.73695 1.73739 3.33706 1.13727C3.93718 0.537154 4.75111 0.200012 5.5998 0.200012H18.3998C19.2485 0.200012 20.0624 0.537154 20.6625 1.13727C21.2627 1.73739 21.5998 2.55132 21.5998 3.40001V22.6C22.0242 22.6 22.4311 22.7686 22.7312 23.0686C23.0312 23.3687 23.1998 23.7757 23.1998 24.2C23.1998 24.6244 23.0312 25.0313 22.7312 25.3314C22.4311 25.6314 22.0242 25.8 21.5998 25.8H16.7998C16.3755 25.8 15.9685 25.6314 15.6684 25.3314C15.3684 25.0313 15.1998 24.6244 15.1998 24.2V21C15.1998 20.5757 15.0312 20.1687 14.7312 19.8686C14.4311 19.5686 14.0242 19.4 13.5998 19.4H10.3998C9.97546 19.4 9.56849 19.5686 9.26843 19.8686C8.96838 20.1687 8.7998 20.5757 8.7998 21V24.2C8.7998 24.6244 8.63123 25.0313 8.33118 25.3314C8.03112 25.6314 7.62415 25.8 7.1998 25.8H2.3998C1.97546 25.8 1.56849 25.6314 1.26843 25.3314C0.968376 25.0313 0.799805 24.6244 0.799805 24.2C0.799805 23.7757 0.968376 23.3687 1.26843 23.0686C1.56849 22.7686 1.97546 22.6 2.3998 22.6V3.40001ZM7.1998 5.00001H10.3998V8.20001H7.1998V5.00001ZM10.3998 11.4H7.1998V14.6H10.3998V11.4ZM13.5998 5.00001H16.7998V8.20001H13.5998V5.00001ZM16.7998 11.4H13.5998V14.6H16.7998V11.4Z"
      fill="url(#paint0_linear_155_2306)" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.3998 3.40001C2.3998 2.55132 2.73695 1.73739 3.33706 1.13727C3.93718 0.537154 4.75111 0.200012 5.5998 0.200012H18.3998C19.2485 0.200012 20.0624 0.537154 20.6625 1.13727C21.2627 1.73739 21.5998 2.55132 21.5998 3.40001V22.6C22.0242 22.6 22.4311 22.7686 22.7312 23.0686C23.0312 23.3687 23.1998 23.7757 23.1998 24.2C23.1998 24.6244 23.0312 25.0313 22.7312 25.3314C22.4311 25.6314 22.0242 25.8 21.5998 25.8H16.7998C16.3755 25.8 15.9685 25.6314 15.6684 25.3314C15.3684 25.0313 15.1998 24.6244 15.1998 24.2V21C15.1998 20.5757 15.0312 20.1687 14.7312 19.8686C14.4311 19.5686 14.0242 19.4 13.5998 19.4H10.3998C9.97546 19.4 9.56849 19.5686 9.26843 19.8686C8.96838 20.1687 8.7998 20.5757 8.7998 21V24.2C8.7998 24.6244 8.63123 25.0313 8.33118 25.3314C8.03112 25.6314 7.62415 25.8 7.1998 25.8H2.3998C1.97546 25.8 1.56849 25.6314 1.26843 25.3314C0.968376 25.0313 0.799805 24.6244 0.799805 24.2C0.799805 23.7757 0.968376 23.3687 1.26843 23.0686C1.56849 22.7686 1.97546 22.6 2.3998 22.6V3.40001ZM7.1998 5.00001H10.3998V8.20001H7.1998V5.00001ZM10.3998 11.4H7.1998V14.6H10.3998V11.4ZM13.5998 5.00001H16.7998V8.20001H13.5998V5.00001ZM16.7998 11.4H13.5998V14.6H16.7998V11.4Z"
      fill="url(#paint0_linear_155_2306)"
      fill-opacity="0.2" />

    <defs>
      <linearGradient id="paint0_linear_155_2306"
                      x1="13.3333"
                      y1="0"
                      x2="13.3333"
                      y2="26.6667"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#59BEE5'}` : color" />
        <stop offset="1" :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#118EBE'}` : color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>
